/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';


/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// LIST : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    list: {
        '& .list-item': {
            display: 'inline-flex',
			alignItems: 'center',
            cursor: 'pointer',
            lineHeight: pxToEm(24),
            margin: pxToEm(5),
            '& .option-text': {
                opacity: 0.5,
                fontSize: pxToEm(16),
                fontWeight: theme.typography.weight.medium,
                marginLeft: pxToEm(3)
            }
        }
    }
});